export default {
  CPQ: {
    "button.createQuote": "Angebot erstellen",
    "dialog.confirm.genericDelete.subtitle":
      "Möchten Sie dieses Element wirklich löschen?",
    "opportunity.title": "Gelegenheit",
    "opportunity.heading": "Gelegenheit {{name}} {{id}}",
    "cart.title": "Warenkorb",
    "button.addQuote": "Angebot hinzufügen",
    "button.addLineItem": "Neue Position",
    "dialog.addLineItem.title": "Neue Position",
    "button.presets": "Voreinstellungen",
    "button.upload": "Hochladen",
    "button.archive": "Archivieren",
    "button.createOpportunity": "Gelegenheit erstellen",
    "button.cancel": "Abbrechen",
    "button.save": "Ok",
    "button.reset": "Zurücksetzen",
    "button.confirm": "Bestätigen",
    "button.goToCatalog": "Zum Katalog",
    "button.inventoryDocumentation": "Bestandsdokumentation",
    "button.download": "Herunterladen",
    "button.start": "Starten",
    "button.logout": "Abmelden",
    "button.addCustomProduct": "Benutzerdefiniertes Produkt",
    "button.addProduct": "Produkt",
    "button.addFilter": "Filter hinzufügen",
    "button.delete": "Löschen",
    "select.language": "Sprache",
    "dialog.createOpportunity.subtitle": "Eine neue Gelegenheit erstellen",
    "dialog.updateOpportunity.title": "Gelegenheit bearbeiten",
    "dialog.updateOpportunity.subtitle": "Eine bestehende Gelegenheit anpassen",
    "button.footer.backToOverview": "Zurück zur Übersicht",
    "button.footer.saveAndExit": "Speichern und beenden",
    "footer.status.title": "Status",
    "button.footer.setStatusManually": "Status manuell setzen",
    "button.footer.generateDocument": "Dokument erstellen",
    "button.preview": "Vorschau",
    "button.footer.backToConfiguration": "Zurück zur Konfiguration",
    "button.addConfigurableProduct": "Konfigurierbares Produkt hinzufügen",
    "buttons.addConfigurationToItemGroupsButtonSelect.label":
      "Zum Angebot hinzufügen",
    "button.unarchiveOpportunity": "Wiederherstellen",
    "button.archiveOpportunity": "Archivieren",
    "button.addItemGroup": "Neue Gruppe",
    "button.updateItemGroup": "Bearbeiten",
    "dialog.createCustomer.title": "Kunden erstellen",
    "dialog.createCustomer.subtitle": "Einen neuen Kunden erstellen",
    "dialog.createCompany.title": "Firma erstellen",
    "dialog.createCompany.subtitle": "Eine neue Firma erstellen",
    "dialog.addLineItem.input.label.lineItemName": "Positionsname",
    "dialog.createOpportunity.input.label.opportunityName": "Name",
    "dialog.createOpportunity.input.label.customer": "Kunde",
    "dialog.createOpportunity.input.label.zipCode": "Postleitzahl",
    "dialog.createOpportunity.input.label.city": "Stadt",
    "dialog.createOpportunity.input.label.description": "Beschreibung",
    "dialog.createOpportunity.title": "Neue Gelegenheit",
    "dialog.createOpportunity.input.validFrom.label": "Gültig ab",
    "dialog.createOpportunity.input.validTo.label": "Gültig bis",
    "dialog.configuratorMode.title": "Neues Angebot erstellen",
    "dialog.configuratorMode.option.configurator.title": "Konfiguration",
    "dialog.configuratorMode.option.configurator.description":
      "Gesamtsystemkonfiguration",
    "dialog.configuratorMode.option.expressMode.title": "Expressmodus",
    "dialog.configuratorMode.option.expressMode.description":
      "Einzelartikelbestellung",
    "dialog.configuratorMode.description": "Wählen Sie Ihren bevorzugten Modus",
    "dialog.confirm.unarchiveQuote.title": "Angebot wiederherstellen",
    "dialog.confirm.unarchiveQuote.description":
      "Möchten Sie dieses Angebot wirklich wiederherstellen?",
    "dialog.confirm.archiveQuote.title": "Angebot archivieren",
    "dialog.confirm.archiveQuote.description":
      "Möchten Sie dieses Angebot wirklich archivieren?",
    "dialog.confirm.unarchiveOpportunity.title": "Gelegenheit wiederherstellen",
    "dialog.confirm.unarchiveOpportunity.description":
      "Möchten Sie diese Gelegenheit wirklich wiederherstellen?",
    "dialog.confirm.archiveOpportunity.title": "Gelegenheit archivieren",
    "dialog.confirm.archiveOpportunity.description":
      "Möchten Sie diese Gelegenheit wirklich archivieren?",
    "dialog.confirm.setOptional.title": "Optional festlegen",
    "dialog.confirm.unsetOptional.title": "Optional aufheben",
    "dialog.confirm.setOptional.subtitle":
      "Möchten Sie dieses Element wirklich als optional festlegen?",
    "dialog.confirm.unsetOptional.subtitle":
      "Möchten Sie dieses Element wirklich nicht mehr als optional festlegen?",
    "dialog.confirm.genericDelete.title": "Löschen",
    "dialog.addProducts.title.addProduct": "Produkte auswählen",
    "dialog.addItemGroup.title": "Neue Gruppe",
    "dialog.addItemGroup.input.label.itemGroupName": "Gruppenname",
    "dialog.updateItemGroup.title": "Gruppe bearbeiten",
    "dialog.updateItemGroup.input.label.itemGroupName": "Gruppenname",
    "dialog.updateLineItem.title": "Position bearbeiten",
    "dialog.updateLineItem.input.label.itemGroupName": "Positionsname",
    "dialog.updateDefault.title": "Bearbeiten",
    "dialog.updateDefault.input.label.name": "Name",
    "dialog.addCustomProduct.title": "Benutzerdefiniertes Produkt hinzufügen",
    "dialog.addCustomProduct.identifier": "Kennung",
    "dialog.addCustomProduct.partId": "Artikelnummer",
    "dialog.addCustomProduct.name": "Name",
    "dialog.addCustomProduct.description": "Beschreibung",
    "dialog.addCustomProduct.customer": "Kunde",
    "dialog.addCustomProduct.productTypeId": "Produkttyp",
    "dialog.addCustomProduct.productStateId": "Produktzustand",
    "dialog.addCustomProduct.isShared": "Gemeinsames Produkt",
    "dialog.addCustomProduct.isActive": "Aktiv",
    "breadcrumb.opportunities": "Gelegenheiten",
    "breadcrumb.quotes": "Angebote",
    "breadcrumb.itemGroups": "Gruppen",
    "breadcrumb.archive": "Archiv",
    "breadcrumb.configurator": "Konfigurator",
    "breadcrumb.expressMode": "Expressmodus",
    "breadcrumb.lineItems": "Positionen",
    "breadcrumb.overview": "Übersicht",
    "breadcrumb.catalog": "Katalog",
    "breadcrumb.salesQuotationView": "Verkaufsangebotansicht",
    "breadcrumb.summaryView": "Zusammenfassung",
    "breadcrumb.ManagementView": "Verwaltungsansicht",
    "breadcrumb.quoteInfo": "Angebotsinfo",
    "breadcrumb.texts": "Texte",
    "breadcrumb.documentGeneration": "Dokumentenerstellung",
    "header.opportunity": "Gelegenheit",
    "header.opportunities": "Gelegenheiten",
    "header.quoteDetails": "Angebot",
    "header.itemGroupDetails": "Gruppe",
    "header.archive": "Archiv",
    "header.configurator": "Konfigurator",
    "header.expressMode": "Expressmodus",
    "header.lineItemDetails": "Position",
    "header.presets": "Voreinstellungen",
    "dropZone.label": "Ziehen und Ablegen oder Durchsuchen",
    "dropZone.isDragActive.label": "Hier ablegen",
    "fileUpload.label": "Stockbilder",
    "filters.input.label.identifier": "Name",
    "filters.input.label.zipCode": "Postleitzahl",
    "filters.input.label.city": "Stadt",
    "filters.input.label.customer": "Kunde",
    "filters.input.label.status": "Status",
    "filters.input.label.search": "Suchen",
    "quote.property.label.uniqueNumberString": "Angebotsnummer",
    "quote.property.label.name": "Name",
    "quote.property.label.description": "Beschreibung",
    "quote.property.label.region": "Region",
    "quote.property.label.revision": "Revisionsnummer",
    "quote.property.label.createdBy": "Erstellt von",
    "quote.property.label.customer": "Kunde",
    "quote.property.label.lastUpdatedOn": "Zuletzt aktualisiert am",
    "quote.property.label.lastUpdatedBy": "Zuletzt aktualisiert von",
    "quote.property.label.status": "Status",
    "accordion.itemGroup.title": "Gruppe",
    "itemGroup.name": "Gruppenname",
    "table.actions.deleteRow": "Löschen",
    "table.lineItems.header.articleNumber": "Artikelnummer",
    "table.lineItems.header.partId": "Teilenummer",
    "table.lineItems.header.name": "Name",
    "table.lineItems.header.identifier": "Kennung",
    "table.lineItems.header.productIdentifier": "Produktkennung",
    "table.lineItems.header.description": "Beschreibung",
    "table.lineItems.header.quantity": "Menge",
    "table.lineItems.header.actions": "Aktionen",
    "table.lineItems.header.optional": "Optional",
    "table.lineItems.header.company": "Firma",
    "table.lineItems.actions.cloneRow": "Duplizieren",
    "table.lineItems.actions.deleteRow": "Löschen",
    "table.lineItems.actions.showBOM": "BOM anzeigen",
    "table.lineItems.actions.showSummary": "Summary anzeigen",
    "catalog.productTable.header.favorit": "Favorit",
    "catalog.productTable.header.preview": "Vorschau",
    "catalog.productTable.header.articleNumber": "Artikelnummer",
    "catalog.productTable.header.name": "Name",
    "catalog.productTable.header.description": "Beschreibung",
    "catalog.productTable.header.cost": "Kosten",
    "catalog.productTable.header.totalCost": "Gesamtkosten",
    "catalog.productTable.header.listPrice": "Listenpreis",
    "catalog.productTable.header.actions": "Menge",
    "catalog.productTable.header.createdByName": "Erstellt von",
    "catalog.productTable.header.createdOn": "Erstellt am",
    "catalog.productTable.header.lastUpdatedOn": "Zuletzt aktualisiert am",
    "catalog.productTable.header.lastUpdatedByName": "Zuletzt aktualisiert von",
    "catalog.productTable.buttons.addProductToGroup": "Hinzufügen",
    "catalog.productTable.buttons.addAllProductsToGroup": "Alle hinzufügen",
    "catalog.productTable.menu.addLineItemToNewGroup": "Neue Gruppe erstellen",
    "catalog.buttons.showLineItems": "Positionen anzeigen",
    "catalog.buttons.columnsSelection": "Spalten",
    "buttons.toggleSideView.label": "Seitenansicht",
    "product.types.tooltip.Configurable": "Konfigurierbar",
    "product.types.tooltip.NonConfigurable": "Nicht konfigurierbar",
    "product.types.tooltip.PreConfigured": "Vorkonfiguriert",
    "product.types.tooltip.configurationStatus.toConfigure": "Zu konfigurieren",
    "product.types.tooltip.configurationStatus.complete":
      "Konfiguration abgeschlossen",
    "product.types.tooltip.configurationStatus.incomplete":
      "Konfiguration unvollständig",
    "product.status.text.toConfigure": "Konfigurieren",
    "product.status.text.complete": "Konfiguriert",
    "product.status.text.incomplete": "Bearbeiten",
    "productsTable.tree.filter": "Filter",
    "productsTable.tree.categoriesToggleText": "Kategorien",
    "relatedProducts.title": "Verwandte Produkte",
    "relatedProducts.noProducts": "Keine Produkte",
    "alternativeProducts.title": "Alternative Produkte",
    "table.itemGroups.title": "Projekt",
    "table.itemGroups.header.rank": "Rang",
    "table.itemGroups.header.moveRow": "Zeile verschieben",
    "table.itemGroups.header.name": "Name",
    "table.itemGroups.header.description": "Beschreibung",
    "table.itemGroups.header.partId": "Part ID",
    "table.itemGroups.header.managingEntity": "Verwaltende Einheit (ME)",
    "table.itemGroups.header.priceList": "Preisliste",
    "table.itemGroups.header.supportingEntity": "Unterstützende Einheit (SE)",
    "table.itemGroups.header.qty": "Menge",
    "table.itemGroups.header.itemCost": "Artikelkosten",
    "table.itemGroups.header.costListPricing": "Cost+/List-Preise",
    "table.itemGroups.header.markup": "Aufschlag",
    "table.itemGroups.header.markupPercentage": "Kostenaufschlag (%)",
    "table.itemGroups.header.itemList": "Artikelliste",
    "table.itemGroups.header.totalList": "Gesamtliste",
    "table.itemGroups.header.discount": "Rabatt",
    "table.itemGroups.header.discount2": "Rabatt 2",
    "table.itemGroups.header.discount3": "Rabatt 3",
    "table.itemGroups.header.discount4": "Rabatt 4",
    "table.itemGroups.header.totalDiscount": "Gesamtrabatt",
    "table.itemGroups.input.label.markup": "Aufschlag",
    "table.itemGroups.input.label.discount": "Rabatt",
    "table.itemGroups.input.label.discount2": "Rabatt 2",
    "table.itemGroups.input.label.discount3": "Rabatt 3",
    "table.itemGroups.input.label.discount4": "Rabatt 4",
    "table.itemGroups.input.label.markupPercentage": "Aufschlag (%)",
    "table.itemGroups.input.label.discountPercentage": "Rabatt (%)",
    "table.itemGroups.input.label.discount2Percentage": "Rabatt 2 (%)",
    "table.itemGroups.input.label.discount3Percentage": "Rabatt 3 (%)",
    "table.itemGroups.input.label.discount4Percentage": "Rabatt 4 (%)",
    "table.itemGroups.input.label.serviceDiscountPercentage": "Rabatt 2 (%)",
    "table.itemGroups.input.label.bonusDiscountPercentage": "Rabatt 3 (%)",
    "table.itemGroups.input.label.projectDiscountPercentage": "Rabatt 4 (%)",
    "table.itemGroups.header.discountPercentage": "Rabatt (%)",
    "table.itemGroups.header.discount2Percentage": "Rabatt 2 (%)",
    "table.itemGroups.header.discount3Percentage": "Rabatt 3 (%)",
    "table.itemGroups.header.discount4Percentage": "Rabatt 4 (%)",
    "table.itemGroups.header.totalDiscountPercentage": "Gesamtrabatt (%)",
    "table.itemGroups.header.totalNet": "Gesamtnetto",
    "table.itemGroups.header.margin": "Bruttomarge",
    "table.itemGroups.header.cost": "Kosten",
    "table.itemGroups.header.actions": "Aktionen",
    "table.itemGroups.header.totalCost": "Gesamtkosten",
    "table.itemGroups.header.listPrice": "Listenpreis",
    "table.itemGroupsOptional.title": "Optional",
    "categories.sharedProducts": "Geteilte Produkte",
    "categories.customProducts": "Benutzerdefinierte Produkte",
    "catalog.productTable.buttons.addProductToLineItem":
      "Zur Position hinzufügen",
    "catalog.productTable.buttons.addAllProductsToLineItem":
      "Alle zu Position hinzufügen",
    "catalog.productTable.buttons.addProductsToQuote": "Zum Angebot hinzufügen",
    "catalog.productTable.buttons.addAllProductsToQuote":
      "Alle zum Angebot hinzufügen",
    "quote.buttons.exportToExcel": "Exportieren",
    "catalog.selectACategoryFirst": "Zuerst eine Kategorie auswählen",
    "button.import": "Importieren",
    "dialog.importExcel.title": "Excel importieren",
    "dialog.createQuote.title": "Angebot erstellen",
    "dialog.createQuote.subtitle": "Ein neues Angebot erstellen",
    "dialog.createQuote.input.label.name": "Name",
    "dialog.createQuote.input.label.description": "Beschreibung",
    "dialog.createQuote.input.label.region": "Region",
    "dialog.createQuote.input.label.customer": "Kunde",
    "dialog.updateQuote.title": "Angebot bearbeiten",
    "dialog.updateQuote.subtitle": "Ein bestehendes Angebot anpassen",
    "button.uploadGeneric.placeholder": "Datei hochladen",
    "checkbox.import.label.override":
      "Hier klicken, um bestehende Einträge zu überschreiben",
    priceListSelectLabel: "Preisliste",
    currencySelectLabel: "Währung",
    "button.goBackToOpportunities": "Zurück zu Gelegenheiten",
    "button.goBackToOpportunity": "Zurück zur Gelegenheit",
    "button.goBackToQuote": "Zurück zum Angebot",
    "item.property.label.note": "Kundenposition / Anlagenposition",
    "item.property.label.listPrice": "Listenpreis",
    "item.property.label.totalList": "Gesamtlistenpreis",
    "item.property.label.discount": "Rabatt",
    "item.property.label.totalDiscount": "Gesamtrabatt",
    "item.property.label.totalCost": "Gesamtkosten",
    "item.property.label.totalNet": "Gesamtnettopreis",
    "item.property.label.status": "Status",
    "item.property.label.name": "Name",
    "item.property.label.partId": "Artikelnummer",
    "item.property.label.description": "Beschreibung",
    "item.property.label.quantity": "Menge",
    "subItem.property.label.totalList": "Liste",
    "subItem.property.label.totalCost": "Kosten",
    "subItem.property.label.totalNet": "Netto",
    "lineItems.bom.label": "Stückliste",
    "priceSummary.totalCost": "Gesamtkosten",
    "priceSummary.totalList": "Gesamtliste",
    "priceSummary.totalNet": "Gesamtnetto",
    "dialog.requestQuote.title": "Anfrage senden",
    "select.topBottom.option.label.top": "List",
    "select.topBottom.option.label.bottom": "Cost+",
    "priceList.select.confirm.title": "Möchten Sie fortfahren?",
    "priceList.select.confirm.subtitle":
      "Das Ändern der Preisliste auf dieser Ebene überschreibt alle Preislisten auf unteren Ebenen.",
    "toast.error.unknown": "Ein Fehler ist aufgetreten",
    "toast.success.itemWasAddedToQuote": "Gruppe wurde erstellt",
    "toast.success.groupCreated": "Item wurde zum Angebot hinzugefügt",
    "toast.success.groupWithItemsCreated":
      "Gruppe wurde erstellt und Items hinzugefügt",
    "toast.success.itemWasAddedToCart": "Zum Warenkorb hinzugefügt",
    "form.field.label.customerNumber": "Kundennummer",
    "form.field.label.companyName": "Firmenname",
    "form.field.label.company": "Firma",
    "form.field.label.name": "Name",
    "form.field.label.contactSalutation": "Anrede",
    "form.field.label.contactTitle": "Titel",
    "form.field.label.contactFirstName": "Vorname",
    "form.field.label.contactLastName": "Nachname",
    "form.field.label.street": "Straße",
    "form.field.label.streetNumber": "Nummer",
    "form.field.label.postalCode": "Postleitzahl",
    "form.field.label.town": "Stadt",
    "form.field.label.country": "Land",
    "form.field.label.emailAddress": "E-Mail",
    "form.field.label.phoneNumber": "Telefon",
    "form.field.label.mobileNumber": "Mobil",
    "form.field.label.companyId": "Firma",
    "form.field.label.description": "Beschreibung",
    "form.field.error.email": "E-Mail-Adresse ist ungültig",
    "quoteInfo.buttons.addNewCustomer": "Neuen Kunden hinzufügen",
    "quoteInfo.buttons.addNewCompany": "Neue Firma hinzufügen",
    "quoteInfo.buttons.addNewSalesLocation": "Vertrieb hinzufügen",
    "quoteInfo.buttons.assignSalesLocation": "Zuweisen",
    "quoteInfo.buttons.assignCustomer": "Kunde zuweisen",
    "quoteInfo.buttons.save": "Speichern",
    "quoteInfo.general.header": "Allgemeine Informationen",
    "quoteInfo.general.quoteId": "Angebots-ID",
    "quoteInfo.general.quote.uniqueNumberString": "Angebotsnummer",
    "quoteInfo.general.opportunity.uniqueNumberString": "Gelegenheitsnummer",
    "quoteInfo.general.currency": "Währung",
    "quoteInfo.general.createdByName": "Erstellt von",
    "quoteInfo.general.quoteCreationDate": "Erstellungsdatum des Angebots",
    "quoteInfo.general.lastUpdatedByName": "Zuletzt aktualisiert von",
    "quoteInfo.general.lastUpdatedOn": "Zuletzt aktualisiert am",
    "quoteInfo.salesLocation.header": "Vertrieb",
    "quoteInfo.customer.header": "Kunde",
    "quoteInfo.customer.customerNumber": "Kundennummer",
    "quoteInfo.customer.companyName": "Firmenname",
    "quoteInfo.customer.contactSalutation": "Anrede",
    "quoteInfo.customer.contactFirstName": "Vorname",
    "quoteInfo.customer.contactLastName": "Nachname",
    "quoteInfo.customer.contactTitle": "Titel",
    "quoteInfo.customer.street": "Straße",
    "quoteInfo.customer.streetNumber": "Straßennummer",
    "quoteInfo.customer.postalCode": "Postleitzahl",
    "quoteInfo.customer.town": "Stadt",
    "quoteInfo.customer.country": "Land",
    "quoteInfo.customer.emailAddress": "E-Mail",
    "quoteInfo.customer.phoneNumber": "Telefonnummer",
    "quoteInfo.customer.mobileNumber": "Mobilnummer",
    "dialog.createSalesLocation.title": "Vertrieb erstellen",
    "dialog.createSalesLocation.subtitle": "Einen neuen Vertrieb erstellen",
    "quoteInfo.customer.salesLocations.header": "Vertrieb",
    "quoteInfo.customer.salesLocations.salesLocationName":
      "Name des Verkaufsstandorts",
    "quoteInfo.customer.salesLocations.contactTitle": "Titel",
    "quoteInfo.customer.salesLocations.contactSalutation": "Anrede",
    "quoteInfo.customer.salesLocations.contactFirstName": "Vorname",
    "quoteInfo.customer.salesLocations.contactLastName": "Nachname",
    "quoteInfo.customer.salesLocations.street": "Straße",
    "quoteInfo.customer.salesLocations.streetNumber": "Straßennummer",
    "quoteInfo.customer.salesLocations.postalCode": "Postleitzahl",
    "quoteInfo.customer.salesLocations.town": "Stadt",
    "quoteInfo.customer.salesLocations.country": "Land",
    "quoteInfo.customer.salesLocations.emailAddress": "E-Mail",
    "quoteInfo.customer.salesLocations.phoneNumber": "Telefonnummer",
    "quoteInfo.customer.salesLocations.mobileNumber": "Mobilnummer",
    "dialog.addCustomProduct.priceCost.value": "Wert",
    "dialog.addCustomProduct.priceCost.validFrom": "Gültig von",
    "dialog.addCustomProduct.priceCost.validTo": "Gültig bis",
    "dialog.addCustomProduct.price": "Preis",
    "dialog.addCustomProduct.cost": "Kosten",
    "productDetails.partId": "Artikelnummer",
    "productDetails.listPrice": "Listenpreis",
    "productDetails.cost": "Kosten",
    "searchField.label": "Suchen",
    "SERVER_ERROR.DISCOUNT_EXCEEDS_LIMIT": "Rabatt überschreitet das Limit",
    "SERVER_ERROR.PRODUCT_IS_IN_USE":
      "Produkt wird verwendet und kann nicht gelöscht werden",
    "filter.filterAttributeInput.label": "Attribut",
    "filter.filterOperatorInput.label": "Operator",
    "filter.filterValueInput.label": "Wert",
    "filter.button.applyFilter": "Anwenden",
    "filter.button.clearAllFilter": "Alle löschen",
    "toast.error.filterAlreadyPresent": "Filter ist bereits vorhanden",
    "selectionBanner.text": "{{selectedProducts}} Produkte ausgewählt",
    "selectionBanner.clearSelection.text": "Auswahl löschen",
    "cart.label.emptyCart": "Ihr Warenkorb ist leer",
    "cart.button.addConfiguration": "Konfiguration hinzufügen",
    "cart.button.addArticle": "Artikel hinzufügen",
    "cart.button.saveShoppingCart": "Save shopping cart",
    "cart.button.printShoppingCart": "Print shopping cart",
    "cart.button.import": "Import",
    "cart.button.export": "Export",
    "cart.summary.subtotal.label": "Zwischensumme",
    "cart.summary.totalNet.label": "Gesamtnetto",
    "cart.summary.button.requestQuote": "Angebot anfordern",
    "cart.summary.button.proceedToCheckout": "Weiter zur Kasse",
    "quotes.table.uniqueNumberString": "Bezeichner",
    "quotes.table.name": "Name",
    "quotes.table.lastUpdatedOn": "Zuletzt aktualisiert",
    "quotes.table.creationDate": "Erstellungsdatum",
    "quotes.table.status": "Status",
    "quotes.table.toolbar.search": "Suchen",
    "infotext.userNotLoggedIn": "Status",
    "buttons.save": "Nicht eingeloggt",
    "buttons.reset": "Download",
    "quotes.table.toolbar.filters.status": "Duplizieren",
    "iconButton.download": "Löschen",
    "iconButton.clone": "Speichern",
    "iconButton.delete": "Zurücksetzen",
    "drawer.showBOM.title": "Stückliste",
    "drawer.showSummary.title": "Summary",
    "workflowSelect.title": "Bitte wählen Sie einen Workflow",
    "workflowSelect.customer.title": "Kunde",
    "workflowSelect.customer.subTitle":
      "Ein optimierter Arbeitsablauf zum Durchsuchen und Kaufen von Produkten.",
    "workflowSelect.sales.title": "Vertrieb",
    "workflowSelect.sales.subTitle":
      "Konfigurieren, bepreisen und offerieren Sie mit einem integrierten Katalog, der auf Verkäufer zugeschnitten ist.",
    "workflowSelect.projectList.title": "Projektliste",
    "workflowSelect.projectList.subTitle":
      "Verwalten Sie Artikel und Projekte effizient mit einer umfassenden Listenansicht.",
    "moveRowMenu.options.topPosition": "Obere Position",
    "opportunities.quotesTable.header.name": "Name",
    "opportunities.quotesTable.header.description": "Beschreibung",
    "opportunities.quotesTable.header.customer": "Kunde",
    "opportunities.quotesTable.header.quoteNumber": "Angebotsnummer",
    "opportunities.quotesTable.header.createdByName": "Erstellt von",
    "opportunities.quotesTable.header.lastUpdatedByName":
      "Zuletzt aktualisiert von",
    "opportunities.quotesTable.header.lastUpdatedOn": "Zuletzt aktualisiert am",
    "opportunities.quotesTable.header.status": "Status",
    "outputOptionsSelection.checkbox.includeLongText.label":
      "Enthält lange Texte",
    "outputOptionsSelection.checkbox.includePartId.label":
      "Enthält Artikelnummern",
    "outputOptionsSelection.checkbox.includePrices.label": "Enthält Preise",
    "outputOptionsSelection.checkbox.includeDiscounts.label": "Enthält Rabatte",
  },
  translation: { DATA_SHEET: "Technische Informationen" },
  WEG: {
    "appcalc.recommendation.flag": "WEG Empfehlung",
    "btn.askForQuote": "Angebot anfragen",
    "btn.import": "importieren",
    "btn.importConfigId": "GPS ID importieren",
    "btn.loginToEasy": "Return to EASY",
    "btn.sendRequest": "Anfrage senden",
    "btn.setAdministrationArea": "Zugang",
    "button.send": "Senden",
    "button.back": "Zurück",
    "button.upload": "Upload",
    "buttons.addToQuote": "Zur Artikelliste hinzufügen",
    "buttons.backToCart": "Zur Projektliste",
    "buttons.backToRoot": "Zur Startseite",
    "buttons.cancel": "Abbrechen",
    "buttons.confirm": "Bestätigen",
    "buttons.download": "Download",
    "buttons.ExitConfigurationButton": "Projektliste",
    "buttons.ExitWithoutSavingButton": "Beenden",
    "buttons.header.returnToWEG": "Home",
    "buttons.header.returnToWEG.url":
      "https://www.weg.net/catalog/weg/AT/de/Gearboxes-and-Geared-Motors/c/GLOBAL_GEARBOXES",
    "buttons.header.toProjectList": "Konfiguration neu starten",
    "buttons.resetConfiguration": "Reset",
    "buttons.SaveAndExitConfigurationButton": "Speichern & Beenden",
    "buttons.saveAsTemplate": "Vorlage speichern",
    "buttons.SaveConfigurationButton": "Konfiguration Speichern",
    "buttons.AddToProjectList": "Zur Projektliste hinzufügen",
    "buttons.select": "Auswählen",
    "buttons.showAllProjects": "Alle Projekte anzeigen",
    "cart.table.header.configurationId": "GPS ID",
    "cart.table.header.customerId": "Kunden-ID/ TAG Nr",
    "cart.table.header.item": "Artikel",
    "cart.table.header.notes": "Notizen",
    "cart.table.header.quantity": "Menge",
    "cart.table.header.syncSelect": "Syncronisieren",
    "cart.table.header.type": "Type",
    "cart.table.header.priceIndicator": "Preisindikator",
    "cart.table.header.status": "Status",
    "cartViewHeader.button.title": "Neue Konfiguration",
    "config.btn.searchProduct": "Produkt Suchen",
    "description.configurator.appCalc":
      "Bemessen Sie das Produkt anhand der Daten Ihrer Ausrüstung.",
    "description.configurator.productConfigurator":
      "Messen Sie Ihr Produkt mit den Antriebsdaten.",
    "dialog.addToQuote.title": "Bitte wählen Sie eine Artikelliste aus",
    "dialog.administrationArea.header": "Standort",
    "error.invalidGUID": "Ungültige GUID.",
    "error.noPOSfound": "Keine Servicepunkte gefunden.",
    "header.cart.title": "Projektliste",
    "label.configId": "Config ID",
    "label.country": "Land",
    "label.form.city": "Stadt/Ort",
    "label.form.company": "Unternehmen",
    "label.form.companyName": "Firmenname",
    "label.form.country": "Land",
    "label.form.email": "E-Mail",
    "label.form.formCity": "Stadt",
    "label.form.formDistrict": "Bezirk",
    "label.form.formPurchasePlace": "Kaufort",
    "label.form.formRegion": "Region",
    "label.form.formUserComment": "Kommentar",
    "label.form.name": "Vorname",
    "label.form.phone": "Telefon",
    "label.form.phoneNumber": "Telefonnummer",
    "label.form.street": "Straße",
    "label.form.streetNr": "Nr.",
    "label.form.surname": "Nachname",
    "label.form.userInquiry": "Wie lautet Ihre Anfrage?",
    "label.form.zipCode": "PLZ",
    "latestProjects.table.header.batch": "Kommission",
    "latestProjects.table.header.lastChange": "Letzte Änderung",
    "latestProjects.table.header.orderNumber": "Bestellnummer",
    "latestProjects.table.header.projectName": "Projektname",
    "latestProjects.table.header.projectNumber": "Projektnummer",
    "latestProjects.table.title": "Aktuellste Projekte",
    "message.confirmSendQuoteRequest":
      "Mit dem Absenden dieser Anfrage wird der Kostenvoranschlag abgeschlossen und weitere Änderungen werden verhindert.",
    "message.errorSendQuoteRequest":
      "Leider konnte die Anfrage nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "message.successSendQuoteRequest":
      "Wir haben Ihre Anfrage an unsere Verkaufsabteilung weitergeleitet und Sie werden in Kürze eine Bestätigungs-E-Mail erhalten.",
    "modal.ExitConfiguration.note":
      "Vorsicht: Ungespeicherte Änderungen gehen verloren.",
    "modal.ExitConfiguration.title": "Konfiguration verlassen",
    "preselector.page1.linkText": "Kontaktieren Sie uns",
    "preselector.subcaption.text":
      "Finden Sie ein Produkt, das Ihren Bedürfnissen entspricht.",
    "products.buttons.addToQuote": "Zur Artikelliste hinzufügen",
    "products.buttons.configure": "Konfigurieren",
    "title.configurator.appCalc": "Anwendungs-Rechner",
    "title.configurator.preselection": "Gear ProSelect",
    "title.configurator.productConfigurator": "Produkt-Konfigurator",
    "title.confirmSendQuoteRequest": "Angebot anfragen",
    "title.successSendQuoteRequest": "Vielen Dank für Ihre Anfrage!",
    "toast.JmpToEasy.timeout":
      "Easy Endpoint time-out. Bitte versuchen Sie es erneut.",
    "tooltip.copyToClipboard": "Kopieren",
    "subconfigurationNavigation.previousItem": "Zurück",
    "subconfigurationNavigation.nextItem": "Weiter",
    "buttons.edit": "Editieren",
    "response.WegStoreFinderError": "EasyApi liefert Statuscode {{params}}",
    "response.Unauthorized": "SessionId nicht gefunden.",
    "response.NoQuoteFound":
      "Kein Angebot für diese SessionId gefunden: {{params}}",
    "response.SomethingWentWrong": "Etwas ist schief gelaufen: {{params}}",
    "response.NoDownloadManual": "Kein Handbuch gefunden.",
    "response.WrongInputParameters":
      "Die folgenden Eingabeparameter sind erforderlich: {{params}}",
    noQuoteFound:
      "Kein Angebot für die aktuelle Sitzung gefunden {{sessionId}}",
    noConfigurationsFound: "Keine ausgewählten Konfigurationen gefunden",
    noBaseConfigurableFound: "Kein BaseConfigurable gefunden",
    noFromToCharacteristics:
      "Keine FromToCharacteristics für einen oder mehrere der ausgewählten Artikel gefunden",
    "buttons.downloadUserManual": "Benutzerhandbuch",
    footerCopyright: "WEG | Gear ProSelect",
    ProjectListEmptyMsg: "Es gibt keine Projekte",
    "error.projectList.noItems": "Es gibt keine Projekte",
    "error.projectList.incompleteItems":
      "Einige Projekte sind noch unvollständig",
  },
};
